import usePusher from 'hooks/usePusher';
import { useEffect } from 'react';
import useExpensesFilesUploadStore from './useExpensesFilesUploadStore';

const useCleanExpensesFileStore = () => {
  const channel = usePusher();

  useEffect(() => {
    if (!channel) return;

    const handler = (event: { data: { _id: string } }) => {
      const id = event?.data?._id;
      if (!id) return;
      const files = useExpensesFilesUploadStore.getState().getValues();
      const file = files.find((fileState) => fileState.result === id);
      if (!file) return;
      useExpensesFilesUploadStore.getState().remove(file.key);
    };

    channel.bind('expense.deleted', handler);
    return () => {
      channel.unbind('expense.deleted', handler);
    };
  }, [channel]);
};

export default useCleanExpensesFileStore;
